import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { IAccClaimProviderDetails } from '@principle-theorem/principle-core/interfaces';

export interface IAccPatientReferenceForm {
  provider: IAccClaimProviderDetails;
  claimNumber: string;
}

export class AccPatientReferenceFormGroup extends TypedFormGroup<IAccPatientReferenceForm> {
  constructor() {
    super({
      provider: new TypedFormControl<IAccClaimProviderDetails>(undefined, [
        Validators.required,
      ]),
      claimNumber: new TypedFormControl<string>(undefined),
    });
  }
}
